<template>
  <div class="header-controls clearfix ptm">
    <tabs
      v-if="!loaded"
      key="placeholderTabs"
      :tabs="placeholderTabs"
      class="tabs tabs-borderless tabs-loading"
    />
    <draggable-tabs
      v-else-if="loaded && configurationMode"
      :tabs="tabs"
      :visible-tabs="visibleTabs"
      class="tabs tabs-borderless ignore"
      :active="selectedTab.id"
      @selected="onTabSelected"
    />
    <tabs
      v-else
      key="actualTabs"
      :tabs="allTabs"
      class="tabs tabs-borderless ignore"
      :active="selectedTab.id"
      @selected="onTabSelected"
    />
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';
import { Tabs } from 'vue-bootstrap';
import DraggableTabs from '../Configuration/DraggableTabs.vue';

export default {
  components: { Tabs, DraggableTabs },
  props: {
    loaded: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      placeholderTabs: [
        { id: 1, name: '', disabled: true },
        { id: 2, name: '', disabled: true },
        { id: 3, name: '', disabled: true }
      ]
    };
  },
  computed: {
    ...mapGetters('entryForm', ['visibleTabs', 'selectedTab', 'visibleTabsForManager']),
    ...mapState('entryForm', ['tabs', 'isManager']),
    ...mapState('entryFormConfiguration', ['configurationMode']),
    allTabs() {
      return this.isManager ? this.visibleTabsForManager : this.visibleTabs;
    }
  },
  methods: {
    onTabSelected(tabId) {
      if (tabId !== this.tabId) {
        this.setUriFromTab(tabId);
        this.selectTab(tabId);
      }
    },
    ...mapActions('entryFormApi', ['setUriFromTab']),
    ...mapMutations('entryForm', ['selectTab'])
  }
};
</script>
